import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { useAppData, useStaticLink } from "~/api/globals"
import { StyledLink } from "~/components/Helpers/StyledLink/StyledLink"
import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"
import { RouterLink } from "~/components/RouterLink/RouterLink"

import { Button } from "../Button/Button"
import styles from "./index.module.css"

export const ContactsInfo = ({ className, children, isOnDark, showBriefButton, isFooter }) => {
  const context = useAppData()
  const briefLink = useStaticLink("brief")
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  if (!context || !context.contacts || context.contacts.length === 0) {
    return null
  }

  const { contacts } = context

  return (
    <React.Fragment>
      <div className={cn(styles.Wrapper, className)}>
        <div className={cn(styles.Contact, { [styles.FooterContact]: isFooter })}>
          {/* TODO: пока скрываем телефон */}
          {/*<a href={`tel:${contacts.phoneMain[currLang].href}`}>*/}
          {/*  {contacts.phoneMain[currLang].text}*/}
          {/*</a>*/}
          {/*<br />*/}
          <StyledLink
            asComponent="a"
            href={`mailto:${contacts.email[currLang]}`}
            isOnDark={isOnDark}
          >
            <span>{contacts.email[currLang]}</span>
          </StyledLink>
        </div>

        {children}
      </div>

      {showBriefButton && (
        <div className={cn("row", { [styles.ButtonHidden]: currLang === "en" })}>
          <div className={cn("col-sm-6", { "col-md-8 col-xl-6": !isFooter })}>
            <Button
              as={RouterLink}
              className={cn(styles.Button, { [styles.FooterButton]: isFooter })}
              href={briefLink.href}
            >
              {currLang === "ru" ? `Оставить заявку` : `Send brief`}
            </Button>
          </div>
        </div>
      )}
      {/* TODO: пока скрываем телефон */}
      <br />
      <br />
    </React.Fragment>
  )
}

ContactsInfo.Contact = ({ children }) => <div className={styles.Contact}>{children}</div>
